import React from 'react';

const ChatWithUsIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 3.73633V21.9999L7.12976 16.9999H23V3.73633H1Z"
      stroke="#FF5900"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="6.61538" cy="10.2365" r="1.61538" fill="#FA6400" />
    <circle cx="12" cy="10.2365" r="1.61538" fill="#FA6400" />
    <circle cx="17.3846" cy="10.2365" r="1.61538" fill="#FA6400" />
  </svg>
);

export default ChatWithUsIcon;
